import React, { useEffect, useState } from "react";
import "./seeallprojects.scss";
import Navbar from "../landing/header/Navbar";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
// import Presalecards from './PresalesCardAll';
import { useTranslation } from "react-i18next";
import PresalecardsAll from "./PresalesCardAll";
import PresalecardsLive from "./PresalesCardLive";
import PresalecardsUpcoming from "./PresalesCardUpcoming";
import PresalecardsEnded from "./PresalesCardEnded";
import axios from "axios";
import Loader from "../../hooks/loader";
import Environment from "../../utils/Environment";
import ProcessLaunchpad from "../landing/Process/ProcessLaunchpad";
import { Link } from "react-router-dom";

const SeeAllProjects = () => {
  const [mainLoader1, setMainLoader1] = useState(false);
  const [mainLoader2, setMainLoader2] = useState(false);
  const [mainLoader3, setMainLoader3] = useState(false);
  // console.log(mainLoader1, "mainLoader1mainLoader1mainLoader1mainLoader1");

  const [role, setRole] = useState("all");
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [Allprojectssss, setAllprojectssss] = useState([]);

  // console.log("console", Allprojectssss?.leadersCount)
  // console.log("console", Allprojectssss?.totalAmountInUsd)

  const getAllProjectsData = async () => {
    setAllprojectssss([]);
    var config = {
      method: "get",
      url: `${Environment?.Api_Url}/users/homepage-stats`,
      headers: {
        // authorization: `Bearer ${tok}`
      },
    };
    axios(config)
      .then(function (response) {
        const data = response.data;
        setAllprojectssss(response?.data?.data);
      })
      .catch(function (error) {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    getAllProjectsData();
    // fetchProjects(currentPage);
  }, []);

  const formatNumber = (num) => {
    if (num >= 1000000) {
      return (num / 1000000)?.toFixed(1) + "M+";
    } else if (num >= 1000) {
      return (num / 1000)?.toFixed(1) + "k+";
    } else {
      return num?.toString();
    }
  };

  const handleTabSelect = (rolee) => {
    setRole(rolee);
  };
  return (
    <>
      {mainLoader1 && <Loader />}
      {mainLoader2 && <Loader />}
      {mainLoader3 && <Loader />}
      <div className="wrapper-seeallprojects">
        <Navbar />
        <section className="seeallprojects">
          <img
            src="\assets\seeallprojects\allprojects-bg.png"
            alt="img"
            className="img-fluid allprojects-bg"
          />
          <img
            src="\assets\seeallprojects\allprojects-bg-mblnew.png"
            alt="img"
            className="img-fluid allprojects-bg d-none allprojects-bg-mbl"
          />
          <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            id="myVideo"
          >
            <source
              src="\assets\seeallprojects\dark-video.mp4"
              type="video/mp4"
            />
          </video>
          <div className="custom-container">
            <div className="upper-content">
              <p className="top-title">{t("Seeallpro1")}</p>
              <h5 className="head-text">
                {t("Seeallpro2")} <span>{t("Seeallpro3")}</span>
              </h5>
              <div className="twice-btns">
                <a
                  href="https://creators.gems.vip/signup"
                  className="btn-green"
                  target="_blank"
                >
                  Create a Project
                </a>
                <Link to="/signupforproject" className="btn-transparent">
                  Apply for Gems Pro
                </Link>
              </div>
              <div className="user-data">
                <div className="parent">
                  <div className="text">
                    <p>{t("NewBannert4")}</p>
                    {/* <h5><span>{Allprojectssss?.totalInvestor ? formatNumber(Allprojectssss?.totalInvestor + 2669811) : 0}</span></h5> */}
                    <h5>
                      <span>2.5M+</span>
                    </h5>
                  </div>
                  <div className="text">
                    <p>{t("NewBannert5")}</p>
                    {/* <h5><span>{Allprojectssss?.leadersCount ? formatNumber(Allprojectssss?.leadersCount) : 0}</span></h5> */}
                    <h5>
                      <span>3.4K+</span>
                    </h5>
                  </div>
                  <div className="text">
                    <p>{t("NewBannert6")}</p>
                    {/* <h5><span>${Allprojectssss?.totalAmountInUsd ? formatNumber(Allprojectssss?.totalAmountInUsd) : 0}</span></h5> */}
                    <h5>
                      <span>$200M+</span>
                    </h5>
                  </div>
                  <div className="text">
                    <p>{t("NewBannert7")}</p>
                    {/* <h5><span>{Allprojectssss?.totalCountries ? formatNumber(Allprojectssss?.totalCountries) : 0}</span></h5> */}
                    <h5>
                      <span>140+</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="custom-container">
            <div className="pro-projects">
              <h6>
                Gems pro{" "}
                <span>
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="12"
                    viewBox="0 0 13 12"
                    fill="none"
                  >
                    <path
                      d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                      fill="#30F1B6"
                    />
                  </svg>
                  Verified Gems
                </span>
              </h6>
            </div>
          </div>

          <div className="process-launchpad">
            <ProcessLaunchpad />
          </div>
          <div className="custom-container">
            <div className="pro-projects headingpdateflex">
              <h6>gems self serve</h6>
              <p>Gems self serve is built on <svg xmlns="http://www.w3.org/2000/svg" width="63" height="17" viewBox="0 0 63 17" fill="none">
                <g clip-path="url(#clip0_7511_2649)">
                  <path d="M20.2099 15.1833V1.81739H24.6098C26.0689 1.81739 27.1676 2.11786 27.9035 2.7188C28.6393 3.31723 29.0072 4.20612 29.0072 5.38546C29.0072 6.00894 28.8308 6.56481 28.4705 7.04305C28.1151 7.52631 27.6288 7.89939 27.0114 8.1623C27.7397 8.36262 28.3142 8.74822 28.7376 9.3116C29.1609 9.87999 29.3676 10.5535 29.3676 11.3323C29.3676 12.5316 28.977 13.4731 28.1933 14.1567C27.4121 14.8427 26.3083 15.1833 24.8795 15.1833H20.2099ZM21.9865 8.96105V13.736H24.9122C25.7388 13.736 26.3915 13.5257 26.8677 13.1025C27.344 12.6794 27.5834 12.0959 27.5834 11.3573C27.5834 9.7598 26.7039 8.96105 24.9399 8.96105H21.9865ZM21.9865 7.51379H24.6627C25.4389 7.51379 26.0588 7.31848 26.5275 6.93288C26.9912 6.54728 27.2256 6.02646 27.2256 5.36543C27.2256 4.62928 27.0089 4.09595 26.5779 3.76293C26.147 3.4274 25.4893 3.26215 24.6098 3.26215H21.9865V7.51379ZM39.4148 11.6878H33.7751L32.51 15.1858H30.6805L35.8188 1.81739H37.3711L42.5169 15.1858H40.6975L39.4148 11.6878ZM34.3143 10.2405H38.8907L36.5975 3.99329L34.3143 10.2405ZM48.2928 9.22646C46.7732 8.79078 45.6669 8.25495 44.9714 7.62146C44.2784 6.98797 43.9307 6.20424 43.9307 5.27529C43.9307 4.22365 44.3565 3.35229 45.2007 2.66121C46.05 1.97263 47.1487 1.62709 48.5019 1.62709C49.4268 1.62709 50.2533 1.80487 50.9741 2.16042C51.6998 2.51348 52.2567 3.00424 52.6549 3.63022C53.0531 4.25369 53.2521 4.93726 53.2521 5.67592H51.4705C51.4705 4.86715 51.2109 4.23116 50.6943 3.76794C50.1777 3.30722 49.4444 3.07435 48.5019 3.07435C47.6275 3.07435 46.9471 3.26465 46.4582 3.64775C45.9668 4.03335 45.7224 4.56168 45.7224 5.24274C45.7224 5.78859 45.9517 6.25182 46.4204 6.6274C46.8841 7.00299 47.6754 7.34853 48.7943 7.66152C49.9106 7.97451 50.7876 8.32005 51.4176 8.69564C52.0476 9.07122 52.5163 9.50941 52.8212 10.0152C53.1261 10.516 53.2773 11.1094 53.2773 11.788C53.2773 12.8722 52.8515 13.741 52.0022 14.392C51.1505 15.0431 50.0165 15.3686 48.5927 15.3686C47.6678 15.3686 46.8035 15.1933 46.0046 14.8427C45.2058 14.4897 44.5884 14.0064 44.1524 13.3955C43.7165 12.7845 43.5023 12.0884 43.5023 11.3122H45.2839C45.2839 12.1185 45.5838 12.7545 46.1861 13.2202C46.7858 13.6859 47.5872 13.9213 48.5927 13.9213C49.5301 13.9213 50.2458 13.731 50.7447 13.3504C51.2462 12.9723 51.4957 12.454 51.4957 11.803C51.4957 11.147 51.2613 10.6412 50.8027 10.2831C50.3466 9.93006 49.5074 9.57451 48.2928 9.22646ZM63.1633 9.01614H57.3345V13.736H64.1058V15.1833H55.5605V1.81739H64.015V3.26465H57.3345V7.56887H63.1633V9.01614Z" fill="#01141A" />
                  <path d="M8.27388 16.5C12.8592 16.5 16.5789 12.9194 16.5789 8.5C16.5789 4.0831 12.8618 0.5 8.27388 0.5C3.92509 0.5 0.353518 3.72504 0 7.82645H10.9747V9.17105H0C0.353518 13.275 3.92509 16.5 8.27388 16.5Z" fill="#01141A" />
                </g>
                <defs>
                  <clipPath id="clip0_7511_2649">
                    <rect width="63" height="16" fill="white" transform="translate(0 0.5)" />
                  </clipPath>
                </defs>
              </svg></p>
            </div>
          </div>
          <div className="bottom-content">
            <div className="custom-container">
              <Tabs
                onSelect={handleTabSelect}
                defaultActiveKey="all"
                // defaultActiveKey="all"
                id="uncontrolled-tab-example"
                className="allprojects-tab"
              >
                <Tab eventKey="all" title={t("Seeallpro8")}>
                  <PresalecardsAll
                    role={role}
                    setMainLoader1={setMainLoader1}
                  />
                </Tab>
                <Tab eventKey="live" title={t("live")}>
                  <PresalecardsLive
                    role={role}
                    setMainLoader1={setMainLoader1}
                  />
                </Tab>
                <Tab eventKey="upcoming" title={t("Upcoming")}>
                  <PresalecardsUpcoming
                    role={role}
                    setMainLoader1={setMainLoader3}
                  />
                </Tab>
                <Tab eventKey="ended" title={t("Dop-detail3")}>
                  <PresalecardsEnded
                    role={role}
                    setMainLoader1={setMainLoader2}
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SeeAllProjects;
